(function ($) {
	"use strict";

	function initChallengeAnchor() {
		var form = $('body#challenge form[action$="/contact"]');

		if (form.length < 1) {
			return;
		}

		form[0].action += "#newsletter";
	}

	function initListCollectionsProducts() {
		$(".js-list-collections-products").each(function (index, element) {
			var $element = $(element);
			var $buttons = $("[data-handle]");
			var $products = $("[data-collection-handle]");

			$element.on("click", function (event) {
				var $target = $(event.target);
				var handle = $target.data("handle");

				if (handle == null) {
					return;
				}

				$buttons.removeClass("is-active");
				$buttons
					.filter("[data-handle='" + handle + "']")
					.addClass("is-active");

				if (handle === "*") {
					$products.show();
				} else {
					$products.hide();
					$products
						.filter("[data-collection-handle='" + handle + "']")
						.show();
				}
			});
		});
	}

	$(function () {
		initChallengeAnchor();
		initListCollectionsProducts();
	});
})(jQuery);
